import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LeaveRequestDetail } from '../models/leave-request-detail.model';

@Component({
  standalone: false,
  selector: 'app-chapa',
  templateUrl: './chapa.component.html',
  styles: []
})
export class ChapaComponent implements OnInit {
  @Input() className: string;
  @Input() icon?: string;
  @Input() text: string;
  @Input() subText: string;
  @Input() infoExtra: string;
  @Input() actionIcon: string;
  @Input() actionText: string;
  @Input() showButtonDoc: boolean = false;
  @Input() buttonColor: string = "primary";
  @Input() isApprover: boolean = false;
  @Input() leaveDetail: LeaveRequestDetail = new LeaveRequestDetail;
  @Input() hasDocument: boolean = false;
  @Input() leaveRequestDraft: boolean = false;
  @Input() textDraft: string;
  @Input() headerDraft:string;
  @Input() isValidated:boolean;
  @Input() loading = false;
  @Output() ApproveRejectClick = new EventEmitter();
  @Output() ViewDocumentClick = new EventEmitter();
  @Output() actionClick = new EventEmitter();
  noteCancelation:boolean = false;
  constructor(private readonly transloco: TranslocoService) { }

  ngOnInit() {
    if(this.leaveDetail.state?.key == "4"){
      this.noteCancelation = true;
    }else{
      this.noteCancelation = false;
    }
  }

  click() {
    this.actionClick.emit();
  }
  approveReject(value: boolean)
  {
    this.ApproveRejectClick.emit(value);
  }
  viewDocumentLeave()
  {
    this.ViewDocumentClick.emit();
  }
  getDateTime(value: string)
  {
    const date = new Date(value);
    if(date.getMinutes().toString().length == 1)
    {
      return (`${date.toLocaleDateString()} ${date.getHours()}:0${date.getMinutes()}`);

    }
    return date.toLocaleDateString() +' '+date.getHours() + ':' + date.getMinutes();
  }
  isNotsameApprover()
  {
    return (this.leaveDetail.actionApprovers && (this.leaveDetail.actionApprovers.find(x => (x.action == 3 || x.action == 2) && x.userId == this.leaveDetail.state.userId) === undefined));
  }
  getIcon()
  {
    switch (this.leaveDetail.state?.key) {
      case "0":
        return "fa-pen-nib";
      case "3":
        return "fa-frown";
      case "2":
        return "fa-smile";
    }
  }
  getClass()
  {
    switch (this.leaveDetail.state?.key) {
      case "0":
        return "draft";
      case "3":
        return "signed-not-ok";
      case "2":
        return "signed-ok";
    }
  }

  getDescriptionRol()
  {
    const date = new Date(this.leaveDetail.state.stateDate);
    switch (this.leaveDetail.state?.key)
    {
      case "4":
        return this.transloco.translate('leaves.chapa.cancellationReasonLbl', { note: this.leaveDetail.state.note });
      case "3":
        return this.transloco.translate('leaves.chapa.rejectedByLbl', { name: this.leaveDetail.state.userName, date: this.formatStateDate(date) });
      case "2":
        return this.transloco.translate('leaves.chapa.approvedByLbl', { name: this.leaveDetail.state.userName, date: this.formatStateDate(date) });
    }
  }

  private formatStateDate(date: Date): string
  {
    if(date.getMinutes().toString().length == 1)
    {
      return `${date.toLocaleDateString()} ${date.getHours()}:0${date.getMinutes()}`;
    }
    return date.toLocaleDateString() + ' ' + date.getHours() + ':' + date.getMinutes();
  }

  showActionRol()
  {
    return (this.leaveDetail.state?.key == '0' || this.leaveDetail.state?.key == '1');
  }

  workflowApproveShow(): boolean{
    const workflowApprove = this.leaveDetail.configLeaveOu?.leaveTypeOu?.workflowApprove ?? this.leaveDetail.leaveTypeOu.workflowApprove;
    const showRejctBtn = this.leaveDetail.state.key == '2' && workflowApprove?.id == 3;
    const today = new Date().setHours(0, 0, 0, 0);
    const startDate = new Date(this.leaveDetail.startDate).setHours(0, 0, 0, 0);
    return showRejctBtn && today < startDate;
  }
}
